import {customAxios} from "../customAxios";
import { useState} from "react";
import { VehicleImportOverride} from "../../model/Vehicle";

export function useGetVehicleOverride() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<VehicleImportOverride>();
    const [error, setError] = useState<Error>();

    async function execute(vehicleId: number, importId: number) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getVehicleOverride(vehicleId, importId);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getVehicleOverride(vehicleId: number, importId: number): Promise<VehicleImportOverride> {
    const response = await customAxios.get<VehicleImportOverride>(`/v1/vehicle/${vehicleId}/import/${importId}/override`, );
    return response.data;
}

